import { useState, useEffect, useRef } from 'react'
import { useTranslation } from "react-i18next";
import '../translate';
import '../translate/translate';
import '../styles/ProfileModal.css';
import { useAuth } from "../providers/AuthProvider.jsx";


function Deposit({ setIsDepositOpen, setIsDepositBidOpen, setDepositAmount, setDepositMethod, setDepositWallet, setDepositExpiredAt, depositDetailId, setDepositDetailId }) {
    const { user } = useAuth()
    const { t } = useTranslation();

    const [uzsBalance, setUzsBalance] = useState(0.00)
    const [usdBalance, setUsdBalance] = useState(0.00)
    const [rubBalance, setRubBalance] = useState(0.00)
    const [currencyState, setCurrencyState] = useState('usd')
    const [transferOpen, setIsTransferOpen] = useState(false)
    const [userId, setUserId] = useState(null)
    const [method, setMethod] = useState(null)
    const [isAmountValue, setIsAmountValue] = useState(null)
    const [minValue, setMinValue] = useState(null)

    useEffect(() => {
        if(user) {
            setUzsBalance(user.uzsBalance)
            setUsdBalance(user.usdBalance)
            setRubBalance(user.rubBalance)
            setCurrencyState(user.mainWallet)
            setUserId(user.id)

        }
    }, [user])

    useEffect(() => {
        if(currencyState === 'uzs') {
            setMinValue(import.meta.env.VITE_UZS_MIN)
        } else if (currencyState === 'usd') {
            setMinValue(import.meta.env.VITE_USD_MIN)
        } else if (currencyState === 'rub') {
            setMinValue(import.meta.env.VITE_RUB_MIN)
        }
    }, [currencyState])



    const formatNumber = (number) => {
        return new Intl.NumberFormat('ru-RU', {
          style: 'decimal',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(number);
      };


      const depositBidCheck = async (method) => {
        
        const token = localStorage.getItem('token');



        try {
            const response = await fetch(`${import.meta.env.VITE_API_URL}/deposit-bid-check`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ type: 'deposit', method: method,}),
            })


            if (response.ok) {
                const data = await response.json();
                
                
                setDepositAmount(data.detail.amount)
                setDepositMethod(data.detail.method)
                setDepositWallet(data.detail.currency)
                setDepositExpiredAt(data.detail.expired_at)
                setDepositDetailId(data.detail.id)
                setIsDepositBidOpen(true)
                
              } else {
                setMethod(method)
                setIsTransferOpen(true)
              }
        } catch (error) {
            
        }
      
}


      function Transfer({ userId, method, currencyState}) {
        const [isLoading, setIsLoading] = useState(false)
        const [responseModal, setResponseModal] = useState(false)
        const [responseText, setResponseText] = useState("")
        const [responseState, setResponseState] = useState(false)


        const formatInputToNumber = (inputValue) => {
            const cleanedValue = inputValue.replace(/\s/g, ''); // Удалить все пробелы
            const numberValue = parseFloat(cleanedValue); // Преобразовать строку в число
            return numberValue;
        };

        const transferFetch = async (method, wallet, amount) => {
                setIsLoading(true)
                const token = localStorage.getItem('token');


        
                try {
                    const response = await fetch(`${import.meta.env.VITE_API_URL}/deposit`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({ method, wallet, amount, type: 'deposit'}),
                    })
        
        
                    if (response.ok) {
                        const data = await response.json();
                        setIsLoading(false)
                        
                        setDepositAmount(data.detail.amount)
                        setDepositMethod(data.detail.method)
                        setDepositWallet(data.detail.currency)
                        setDepositExpiredAt(data.detail.expired_at)
                        setDepositDetailId(data.detail.id)
                        setIsDepositBidOpen(true)
                        setIsTransferOpen(false)
                      } else {
                        const errorData = await response.json();
                        
                      }
                } catch (error) {
                    
                }
              
        }


        const [value, setValue] = useState("");

        useEffect(() => {
            setValue(minValue)
        }, [minValue])

        const formatNumber = (num) => {
            if (!num) return "";
            const parts = num.toString().split(".");
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            return parts.join(".");
          };
        
          const handleChange = (e) => {
            let inputValue = e.target.value;
            // Удаляем все символы, кроме цифр и точки
            inputValue = inputValue.replace(/[^0-9.]/g, "");
            // Убираем лишние точки
            const parts = inputValue.split(".");
            if (parts.length > 2) {
              inputValue = parts[0] + "." + parts[1];
            }
            // Обновляем состояние с форматированием
            setValue(formatNumber(inputValue));
          };

          const formatButtons = (number) => {
            const formatted = new Intl.NumberFormat('ru-RU', {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(number);
              return formatted.replace(',', '.'); // Заменяет запятую на точку
          };



          function ResponseModal({setIsWithdrawOpen, responseText, responseState }) {

            return (
                <div className={'response-modal-wrapper'}>
                    <img width={40} src={responseState ? "/assets/img/main/success-icon.svg" : "/assets/img/main/error-icon.svg"} alt="" />
                    <p className={'response-modal-title'}>{responseState ? `${t("mp_success")}` : `${t("mp_error")}`}</p>
                    <p>
                        {responseText}
                    </p>
                    <div className={`response-modal-button ${responseState ? "green" : "red"}`} onClick={() => {
                        if(responseState) {
                            setIsWithdrawOpen(false)
                        }
                        setIsLoading(false)
                        setResponseModal(false)
                    }}>OK</div>
                </div>
            )
        }

        const [maxValue, setMaxValue] = useState(null)
        

        useEffect(() => {
            if(currencyState) {
                if(currencyState === 'uzs') {
                    setMaxValue("6 500 000")
                } else if (currencyState === 'usd') {
                    setMaxValue("5 000.00")
                } else if (currencyState === 'rub') {
                    setMaxValue("300 000")
                }
            }
        }, [currencyState])



        return (
            <div className={'profile-modal-wrapper'}>
            <div className={'profile-modal-container'}>
                <img className={'profile-modal-close-button'} src="/assets/img/main/close_button.svg" alt="" onClick={() => setIsDepositOpen(false)}/>
                <div className={'profile-modal-title'}>
                    <span>{`ID #${102000 + userId }`}</span>
                </div>
                <div className={'transfer-method-change-wrap'}>
                    <div className={'transfer-method-left-wrap'}>
                        {method === 'uzcard' && <img width={35} src="/assets/img/main/uzcardlogo.svg" alt="" />}
                        {method === 'humo' && <img style={{"margin": "0 5px"}} width={40} src="/assets/img/main/humologo1.png" alt="" />}
                        {method === 'payme' && <img style={{"margin": "0 5px"}} width={40} src="/assets/img/main/payme-logo.svg" alt="" />}
                        {method === 'click' && <img style={{"margin": "0 5px"}} width={40} src="/assets/img/main/logo_click.svg" alt="" />}
                        <div className={'transfer-method-left-wrap-item'}>
                            {(currencyState === 'rub' || currencyState === 'uzs') && <p>Bank card</p>}
                            {currencyState === 'usd' && <p>Crypto Currency</p>}
                            <span>transfer to {method.toUpperCase()}</span>
                        </div>
                    </div>
                    <div className={'transfer-method-change-button'} onClick={() => {
                        setIsTransferOpen(false)
                    }}>{t("mp_change")}</div>
                </div>
                <div className={'transfer-amount-wrapper'}>
                    <div className={'transfer-amount-title'}>
                        <p>{t("mp_minimum_amount_replenishment")}</p>
                        <p>{currencyState.toUpperCase()} {minValue ? formatNumber(minValue) : ""} </p>
                    </div>
                    <div className={'transfer-amount-input-wrap'}>
                        <div className={'transfer-amount-currency'}>
                            {currencyState.toUpperCase()}
                            <p className={'transfer-amount-currency-wall'}></p>
                        </div>
                        <div style={{"width": "100%", "height": "100%", "padding-right": "10px", "display": "flex", "align-items": "center"}}>
                            <input 
                            className={'transfer-amount-input'} 
                            type="decimal" 
                            placeholder={formatNumber(minValue)}
                            value={formatNumber(value)}
                            onChange={handleChange}
                            />
                        </div>
                    </div>
                    <div className={'transfer-amount-title'}>
                        <p>Bitta to'ldirish summasi</p>
                        <p>{currencyState ? currencyState.toUpperCase() : ""} {minValue ? formatNumber(minValue) : ""} - {currencyState ? currencyState.toUpperCase() : ""} {maxValue ? maxValue : ""}</p>
                    </div>
                </div>
                <div className={'transfer-footer-buttons'}>
                    <div onClick={() => setValue(formatButtons(500000))}>500 000.00 UZS</div>
                    <div onClick={() => setValue(formatButtons(650000))}>650 000.00 UZS</div>
                    <div onClick={() => setValue(formatButtons(900000))}>900 000.00 UZS</div>
                </div>
                <div className={'transfer-continue-button'} onClick={() => {
                    if(formatInputToNumber(value) >= formatInputToNumber(minValue)) {
                        transferFetch(method, currencyState, value)
                    } else {
                        setResponseState(false)
                        setResponseText(`${t("mp_minimum_amount_replenishment")} ${formatNumber(minValue)}`)
                        setResponseModal(true)
                    }
                    // transferFetch(method, currencyState, value)
                    // setIsDepositBidOpen(true)
                }}>
                    {t("mp_continue")}
                </div>
            </div>
            {responseModal && <div className={'profile-modal-wrapper'}><ResponseModal setIsTransferOpen={setIsTransferOpen} responseText={responseText} responseState={responseState} /></div>}
            </div>
        )
      }


    return (
        <div className={'profile-modal-wrapper'}>
            <div className={'profile-modal-container'}>
                <img className={'profile-modal-close-button'} src="/assets/img/main/close_button.svg" alt="" onClick={() => setIsDepositOpen(false)}/>
                <div className={'profile-modal-title'}>
                    <span>{t("mp_deposit")}</span>
                </div>
                <div className={'deposit-currency-wrapper'}>
                    <div className={'deposit-currency-wrap-title'}>
                        {t("mp_select_wallet_to_top_up")}
                    </div>
                    <div className={'deposit-selector-container'}>
                        <p className={'deposit-selector-currency'}>
                            {currencyState.toUpperCase()}
                        </p>
                        <p className={'deposit-selector-currency-wall'}></p>
                        <p className={'deposit-selector-amount'}>{formatNumber({ uzs: uzsBalance, usd: usdBalance, rub: rubBalance }[currencyState] || 0)} ({currencyState.toUpperCase()})</p>
                        {/* <img src="/assets/img/main/arrow-down.svg" alt="" /> */}
                    </div>
                    <div className={'deposit-methods-container'}>
                        <div className={'deposit-methods-container-title'}>
                            {t("mp_all_methods")}
                        </div>
                        <div className={'deposit-methods-available'}>{t("mp_available_methods")}</div>
                        {currencyState === 'uzs' && <div className={'deposit-methods-container-wrap'}>
                            <div className={'deposit-method-wrapper'} onClick={() => {
                                // setMethod('uzcard')
                                // setIsTransferOpen(true)
                                depositBidCheck('uzcard')
                            }}>
                                <div><img className={'deposit-method-wrapper-uzcard-logo'} src="/assets/img/main/uzcardlogo.svg" alt="" /></div>
                                <div>Transfer to UZCARD</div>
                            </div>
                            <div className={'deposit-method-wrapper'} onClick={() => {
                                depositBidCheck('humo')
                                // setMethod('humo')
                                // setIsTransferOpen(true)
                            }}>
                                <div><img className={'deposit-method-wrapper-humo-logo'} src="/assets/img/main/humologo1.png" alt="" /></div>
                                <div>Transfer to HUMO</div>
                            </div>
                            <div className={'deposit-method-wrapper'} onClick={() => {
                                depositBidCheck('payme')
                                // setMethod('payme')
                                // setIsTransferOpen(true)
                            }}>
                                <div><img className={'deposit-method-wrapper-payme-logo'} src="/assets/img/main/payme-logo.svg" alt="" /></div>
                                <div>Transfer to PayMe</div>
                            </div>
                            <div className={'deposit-method-wrapper'} onClick={() => {
                                depositBidCheck('click')
                                // setMethod('click')
                                // setIsTransferOpen(true)
                            }}>
                                <div><img className={'deposit-method-wrapper-uzcard-logo'} src="/assets/img/main/logo_click.svg" alt="" /></div>
                                <div>Transfer to CLICK</div>
                            </div>
                        </div>}
                        {currencyState === 'usd' && <div className={'deposit-methods-container-wrap'}>
                            <div className={'deposit-method-wrapper'} onClick={() => {
                                // setMethod('uzcard')
                                // setIsTransferOpen(true)
                                depositBidCheck('usdt trc20')
                            }}>
                                <div><img className={'deposit-method-wrapper-uzcard-logo'} src="/assets/img/main/tron-logo.svg" alt="" /></div>
                                <div>Transfer to USDT TRC20</div>
                            </div>
                        </div>}
                        {currencyState === 'rub' && <div className={'deposit-methods-container-wrap'}>
                            <div className={'deposit-method-wrapper'} onClick={() => {
                                // setMethod('uzcard')
                                // setIsTransferOpen(true)
                                depositBidCheck('MIR CARD')
                            }}>
                                <div><img className={'deposit-method-wrapper-uzcard-logo'} src="/assets/img/main/mir-logo.svg" alt="" /></div>
                                <div>Transfer to USDT TRC20</div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
            {transferOpen && <Transfer userId={userId} method={method} currencyState={currencyState} isAmountValue={isAmountValue} />}
        </div>
        
    )
}

export default Deposit